document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // ========================================
  // 工具函数
  // ========================================

  function initResponsiveVideo({ wrapper, videoId, firstFrameId, lastFrameId, sources }) {
    const video = document.getElementById(videoId);
    const firstFrame = document.getElementById(firstFrameId);
    const lastFrame  = document.getElementById(lastFrameId);
    const container = document.querySelector(wrapper);
  
    // 判断设备类型
    const width = window.innerWidth;
    let deviceType = "pc";
    if (width <= 768) {
      deviceType = "mobile";
    } else if (width <= 1024) {
      deviceType = "tablet";
    }
  
    const deviceSource = sources[deviceType];
    if (!deviceSource) {
      console.warn(`❗ 未定义 ${deviceType} 对应的视频或图片资源`);
      return;
    }
  
     // 设置资源
    video.src = deviceSource.video;
  
    // ======== 播放逻辑 ========

    const box1Info = document.querySelector(".box1 .box1-info");
  
    // 视频加载完毕，隐藏首帧图
    video.addEventListener("loadeddata", () => {
      firstFrame.style.opacity = "0";
    });
  
    // 视频播放结束后隐藏视频，显示封面图
    video.addEventListener("ended", () => {
      video.style.opacity = "0";
      lastFrame.style.opacity = "1";
      if (box1Info) box1Info.classList.add('active');
    });
  }
  
  

  /**
   * 获取元素中心点坐标和尺寸
   */
  function getRectCenter(el) {
    const rect = el.getBoundingClientRect();
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    return {
      cx: rect.left + scrollLeft + rect.width / 2,
      cy: rect.top + scrollTop + rect.height / 2,
      width: rect.width,
      height: rect.height
    };
  }

  /**
   * 防抖函数
   */
  function debounce(func, wait = 300) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * 创建通用 Tab 切换组件
   */
  function createTabComponent(options) {
    const {
      tabSelector,
      contentSelector,
      markerSelector,
      imgSelector,
      activeClass = "active",
      tabActiveClass = "tab-active"
    } = options;

    const marker = document.querySelector(markerSelector);
    const tabItems = document.querySelectorAll(tabSelector);
    const contents = document.querySelectorAll(contentSelector);
    const imgs = imgSelector ? document.querySelectorAll(imgSelector) : null;

    function moveIndicator(target) {
      if (!marker || !target) return;
      marker.style.left = target.offsetLeft + "px";
      marker.style.width = target.offsetWidth + "px";
    }

    tabItems.forEach((tab, index) => {
      tab.addEventListener("mouseover", (e) => {
        moveIndicator(e.target);

        // 移除所有激活状态
        contents.forEach(c => c.classList.remove(activeClass));
        tabItems.forEach(t => t.classList.remove(tabActiveClass));
        if (imgs) imgs.forEach(i => i.classList.remove(activeClass));

        // 添加当前激活状态
        tab.classList.add(tabActiveClass);
        if (contents[index]) contents[index].classList.add(activeClass);
        if (imgs && imgs[index]) imgs[index].classList.add(activeClass);
      });
    });
  }

  // ========================================
  // Box6, Box7, Box10: Tab 组件（保持原樣）
  // ========================================
  createTabComponent({
    tabSelector: ".box6-tab a",
    contentSelector: ".box6-tab-content>div",
    markerSelector: ".box6-tab .marker2",
    imgSelector: ".box6-content .tab-div .div-img img",
    activeClass: "active",
    tabActiveClass: "active"
  });

  createTabComponent({
    tabSelector: ".box7-tab a",
    contentSelector: ".box7-tab-content>div",
    markerSelector: ".box7-tab .marker2",
    activeClass: "active",
    tabActiveClass: "active"
  });

  createTabComponent({
    tabSelector: ".box10-tab a",
    contentSelector: ".box10-tab-content>div",
    markerSelector: ".box10-tab .marker2",
    activeClass: "active",
    tabActiveClass: "active"
  });

  // ========================================
  // Box1: 视频播放（保持原樣）
  // ========================================

  initResponsiveVideo({
    wrapper: '.box1-video',
    videoId: 'video1',
    firstFrameId: 'videoFirstFrame',
    lastFrameId: 'videoLastFrame',
    sources: {
      pc: {
        video: "https://cdn.shopify.com/videos/c/o/v/e26d76bc335c42dfadcdc3aa480d497e.mp4",
      },
      tablet: {
        video: "https://cdn.shopify.com/videos/c/o/v/e26d76bc335c42dfadcdc3aa480d497e.mp4",
      },
      mobile: {
        video: "https://cdn.shopify.com/videos/c/o/v/da6a8e4171344927b43e90f5e852eaf8.mp4",
      }
    }
  });

  ScrollTrigger.matchMedia({
    // 大屏幕才启用动画
    "(min-width: 1025px)": function() {

      // ========================================
      // 全域變數：保存各區塊的 ScrollTrigger / timeline 實例
      // ========================================
      let box2ScrollTrigger = null;
      let box7ScrollTrigger = null;
      let box9ScrollTrigger = null;
      let box12ScrollTrigger = null;
      let box8Trigger = null;        // 用於 box8 進入視口觸發的 reference

      // ========================================
      // Box2: 滚动文本流动动画
      // ========================================
      function initBox2Animation() {
        const box2 = document.querySelector(".box2");
        const box2Watch = document.querySelector(".watch-icon");
        const box2TextBox = document.querySelector(".box2-info");
        const headlines = gsap.utils.toArray('.headline');

        if (!box2 || !box2TextBox) return;

        // 先 kill 舊的
        if (box2ScrollTrigger) {
          try { box2ScrollTrigger.kill(); } catch (e) {}
          box2ScrollTrigger = null;
        }

        const box2TextBoxHeight = box2TextBox.offsetHeight * 1.2;

        // 若沒 headline，避免除以 0，直接返回（或可繼續做簡單移動）
        if (headlines.length === 0) {
          // fallback: 簡單滾動效果
          box2ScrollTrigger = gsap.to(box2TextBox, {
            y: -box2TextBoxHeight,
            ease: 'none',
            scrollTrigger: {
              trigger: box2,
              start: 'top top',
              end: '+=200%',
              scrub: true,
              pin: true,
            }
          });
          return;
        }

        box2ScrollTrigger = gsap.to(box2TextBox, {
          y: -box2TextBoxHeight,
          ease: 'none',
          scrollTrigger: {
            trigger: box2,
            start: 'top top',
            end: '+=200%',
            scrub: true,
            pin: true,
            onUpdate: function(self) {
              const progress = self.progress;
              const totalHeadlines = headlines.length;
              const visibleCount = 4;
              const visibleWindow = visibleCount / totalHeadlines;

              // 计算可见窗口范围
              const windowStart = -visibleWindow / 2;
              const windowEnd = 1 + visibleWindow / 2;
              const windowCenter = windowStart + (windowEnd - windowStart) * progress;
              const fadeEdge = visibleWindow / 2;

              headlines.forEach((headline, index) => {
                const headlinePosition = index / (totalHeadlines - 1);
                const distanceFromCenter = Math.abs(headlinePosition - windowCenter);

                let opacity = 0;
                let scale = 1;

                if (distanceFromCenter < fadeEdge) {
                  const distanceFromEdge = fadeEdge - distanceFromCenter;
                  const edgeFade = 0.2;

                  // 计算透明度
                  opacity = distanceFromEdge < edgeFade
                    ? distanceFromEdge / edgeFade
                    : 1;
                  opacity = Math.pow(opacity, 0.8);

                  // 计算缩放
                  const scaleAmount = 1 - (distanceFromCenter / fadeEdge);
                  scale = 1 + (scaleAmount * 0.15);
                }

                gsap.set(headline, { opacity, scale });
              });

              // 控制观看图标显示
              if (box2Watch) {
                if (progress >= 0.9) {
                  box2Watch.classList.add("active");
                } else {
                  box2Watch.classList.remove("active");
                }
              }
            }
          }
        })
      }

      // 立即呼叫（首次初始化）
      initBox2Animation();



      // ========================================
      // Box7: 图片变换动画
      // ========================================
      function initBox7Animation() {
        const startImg = document.querySelector("#img-start");
        const finalImg = document.querySelector("#img-final");
        if (!startImg || !finalImg) return;

        // kill 舊的
        if (box7ScrollTrigger) {
          try { box7ScrollTrigger.kill(); } catch (e) {}
          box7ScrollTrigger = null;
        }

        gsap.killTweensOf(startImg);
        gsap.set(startImg, { clearProps: "all" });

        const startRect = getRectCenter(startImg);
        const finalRect = getRectCenter(finalImg);

        const deltaX = finalRect.cx - startRect.cx;
        const deltaY = finalRect.cy - startRect.cy;
        const adjustX = (startRect.width - finalRect.width) / 2;
        const adjustY = (startRect.height - finalRect.height) / 2;

        const isLargeScreen = window.innerWidth >= 1920;
        const bgPosX = isLargeScreen ? "-400px" : "-200px";

        // 建立 timeline（scrollTrigger 會被 timeline 的 .scrollTrigger 保存）
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".box7-s",
            start: "top top",
            end: "+=150% bottom",
            scrub: true,
            pin: true,
            onUpdate: (self) => {
              startImg.classList.toggle("active", self.progress === 1);
            }
          }
        });

        tl.to(startImg, {
          width: finalRect.width,
          height: finalRect.height,
          x: deltaX + adjustX,
          y: deltaY + adjustY,
          backgroundPositionX: bgPosX,
          borderRadius: "30px",
          ease: "none"
        });

        box7ScrollTrigger = tl.scrollTrigger || tl; // 保留 reference，方便 kill
      }

      initBox7Animation();

      // ========================================
      // Box8: 进入视口触发
      // ========================================
      // 我們把 trigger 存起來，以便 resize 時 kill
      const box8Li2 = document.querySelector(".box8-ul .box8-li2");
      if (box8Li2) {
        // kill 舊的（若有）
        if (box8Trigger) {
          try { box8Trigger.kill(); } catch (e) {}
          box8Trigger = null;
        }
        box8Trigger = ScrollTrigger.create({
          trigger: ".box8-li2",
          start: "top 30%",
          once: true,
          onEnter: () => box8Li2.classList.add("active")
        });
      }

      // ========================================
      // Box9: 横向滚动
      // ========================================
      function initBox9Animation() {
        const box9Ul = document.querySelector('.box9-ul');
        if (!box9Ul) return;

        // kill 舊的
        if (box9ScrollTrigger) {
          try { box9ScrollTrigger.kill(); } catch (e) {}
          box9ScrollTrigger = null;
        }

        const ulWidth = box9Ul.offsetWidth;

        // 建立 ScrollTrigger 並把 animation 放到 timeline 裡
        const tl = gsap.timeline();
        tl.to('.box9-ul', { x: -ulWidth / 3 + "px" });

        box9ScrollTrigger = ScrollTrigger.create({
          trigger: ".box9-s",
          start: "top top",
          end: "+=180% bottom",
          scrub: 0.5,
          pin: true,
          animation: tl
        });
      }

      initBox9Animation();

      // ========================================
      // Box12: 钢笔路径动画
      // ========================================
      const path = document.getElementById('pen-path-1');
      const penCanvas = document.getElementById('pen');
      const penText = document.querySelector('.pen-text');

      let currentPenFrame = 0;
      const frameCount = 91;
      const penImages = [];

      if (path && penCanvas) {
        const context = penCanvas.getContext("2d");

        const pathLength = path.getTotalLength();
        path.style.strokeDasharray = pathLength;
        path.style.strokeDashoffset = pathLength;

        penCanvas.width = 737;
        penCanvas.height = 740;

        const getPenFrameUrl = index =>
          `https://cdn.shopify.com/s/files/1/0606/1824/4315/files/10-2_Pen3_${index.toString().padStart(5, '0')}.png`;

        function renderPen() {
          context.clearRect(0, 0, penCanvas.width, penCanvas.height);
          if (penImages[currentPenFrame]) {
            context.drawImage(penImages[currentPenFrame], 0, 0, penCanvas.width, penCanvas.height);
          }
        }

        ScrollTrigger.create({
          trigger: ".box11",
          start: "top bottom",
          once: true,
          onEnter: () => {
            for (let i = 0; i < frameCount; i++) {
              const img = new Image();
              img.src = getPenFrameUrl(i);
              penImages.push(img);
            }
            if (penImages[0]) {
              penImages[0].onload = renderPen;
            }
          }
        });

        // 钢笔路径动画
        function initBox12Animation() {
          // kill 舊的
          if (box12ScrollTrigger) {
            try { box12ScrollTrigger.kill(); } catch (e) {}
            box12ScrollTrigger = null;
          }
        
          box12ScrollTrigger = ScrollTrigger.create({
            trigger: '.box12-s',
            start: 'top top',
            end: '+=300% bottom',
            scrub: true,
            pin: true,
            onUpdate: self => {
              const progress = self.progress;
              penCanvas.style.opacity = progress === 0 ? 0 : 1;
        
              // 更新帧
              let imgIndex = Math.ceil(progress * frameCount);
              currentPenFrame = Math.max(0, imgIndex - 1);
              if (currentPenFrame <= frameCount) renderPen();
        
              // 控制路径透明度
              gsap.to(path, { opacity: currentPenFrame > 55 ? 0 : 1 });

              const penStyle = getComputedStyle(penCanvas);
        
              // 读取 CSS 变量
              const offsetX = parseFloat(penStyle.getPropertyValue('--pen-offset-x'));
              const offsetY = parseFloat(penStyle.getPropertyValue('--pen-offset-y'));
              const penP = document.querySelector('#pen-line');
              const left = penP.getBoundingClientRect().left;
        
              let x = 0, y = 0;
        
              if (progress <= 0.6) {
                // 前60%: 画线
                const t = progress / 0.6;
                const drawLength = pathLength * t;
                path.style.strokeDashoffset = Math.max(pathLength - drawLength, 0);
        
                const atLen = Math.min(Math.max(drawLength, 0), pathLength);
                const pt = path.getPointAtLength(atLen);
        
                const svg = path.ownerSVGElement;
                const svgPoint = svg.createSVGPoint();
                svgPoint.x = pt.x;
                svgPoint.y = pt.y;
                const screenP = svgPoint.matrixTransform(svg.getScreenCTM());

                x = screenP.x - left - offsetX;
                y = screenP.y - offsetY;
        
              } else {
                // 后40%: 笔移到右边
                const t = (progress - 0.6) / 0.4;
        
                const box = document.querySelector(".box12-text");
                if (box) {
                  const boxRect = box.getBoundingClientRect();
                  const targetX = boxRect.right/1.7;
                  const targetY = boxRect.top*1.4;
        
                  const pt = path.getPointAtLength(pathLength);
                  const svg = path.ownerSVGElement;
                  const svgPoint = svg.createSVGPoint();
                  svgPoint.x = pt.x;
                  svgPoint.y = pt.y;
                  const screenP = svgPoint.matrixTransform(svg.getScreenCTM());
        
                  const currentX = screenP.x - left - offsetX;
                  const currentY = screenP.y - offsetY;
        
                  x = currentX + (targetX - currentX) * t;
                  y = currentY + (targetY - currentY) * t;
                }
              }
        
              // 使用 transform 移动
              penCanvas.style.transform = `translate(${x}px, ${y}px)`;

              if (progress >= 0.9) {
                penText.classList.add("active")
              }else{
                penText.classList.remove("active");
              }
            }
          });
        }
        

        // 初次建立
        initBox12Animation();

        // 暴露給外部重新建立（resize 會呼叫）
        window.__initBox12Animation = initBox12Animation;
      }

      // ========================================
      // 全部初始化 / 重建邏輯（供 load 與 resize 使用）
      // ========================================
      function initAllAnimations() {

        const targets = ['.box7-s', '.box9-s']; 
        // 1) kill 所有已存在的 ScrollTrigger（確保乾淨）
        ScrollTrigger.getAll().forEach(st => {
          const triggerEl = st.trigger;
          if (triggerEl && targets.some(sel => triggerEl.matches(sel))) {
            try { st.kill(); } catch (e) {}
          }
        });

        // 2) 清空我們手上的引用（避免 stale references）
        // box2ScrollTrigger = null;
        box7ScrollTrigger = null;
        box9ScrollTrigger = null;
        // box12ScrollTrigger = null;
        // box8Trigger = null;

        // 3) 重新建立每個動畫（順序可依頁面區塊而定）
        // initBox2Animation();
        initBox7Animation();
        initBox9Animation();
        // box8 是在上面建立過一次（若 DOM 存在），但為穩定性我們也嘗試重新建立
        //（若需，亦可把 box8 的建立抽成函式來重用）
        const box8Li2_local = document.querySelector(".box8-ul .box8-li2");
        if (box8Li2_local) {
          box8Trigger = ScrollTrigger.create({
            trigger: ".box8-li2",
            start: "top 30%",
            once: true,
            onEnter: () => box8Li2_local.classList.add("active")
          });
        }

        // box12 的 init 若有定義（pen canvas）
        if (typeof window.__initBox12Animation === "function") {
          window.__initBox12Animation();
        }

        // 4) 最後刷新（用 requestAnimationFrame 確保 layout 穩定）
        requestAnimationFrame(() => {
          ScrollTrigger.refresh(true);
        });
      }
      // ========================================
      // 窗口尺寸变化时重新計算（穩定版）
      // ========================================
      const handleResize = debounce(() => {
        // 直接呼叫統一重建函式（內部會 kill all 並重建）
        initAllAnimations();
      }, 350);

      window.addEventListener('resize', handleResize);

    },
    // 小屏幕禁用动画
    "(max-width: 1024px)": function() {
      ScrollTrigger.getAll().forEach(st => st.kill());
    }

  })

  // ========================================
  // Box11: 视频预加载（保持 IntersectionObserver）
  // ========================================
  const box11Video = document.getElementById('box11-video');
  const box11VideoImg = document.querySelector(".box11-video-img");
  const box11Content = document.querySelector(".box11-content");
  

  ScrollTrigger.create({
    trigger: ".box10",
    start: "top bottom",
    once: true,
    onEnter: () => {
      box11Video.preload = 'auto';
      box11Video.load();
      box11Video.addEventListener('timeupdate', () => {
        if (box11Video.currentTime >= 1) {
          box11Content.classList.add('active');
        }
      });
      box11Video.addEventListener('ended', () => {
        box11VideoImg.classList.add('active');
      });
    }
  });


const box9Div = document.querySelector(".box9-div");
const box9Ul = document.querySelector(".box9-ul");
const box9Item = document.querySelectorAll(".box9-ul li");
const box9ButLi = document.querySelectorAll(".box9-ul-but ul li");
const box9ButLeft = document.querySelector(".box9-ul-but .left");
const box9ButRight = document.querySelector(".box9-ul-but .right");

let viewportW = box9Div.clientWidth;            // 可视区宽
let ulW = box9Ul.scrollWidth;                   // ul 总宽
const box9LiW = box9Item[0].offsetWidth;        // 单个 li 宽（假定都一样）
let maxSteps = Math.max(0, Math.ceil((ulW - viewportW) / box9LiW));
let clickIndex = 0;                             // 当前索引（0 表示最左）

// 初始化按钮状态函数
function updateButtons() {
  // 清除所有 is-false
  box9ButLi.forEach(item => item.classList.remove("is-false"));
  // 左边到头
  if (clickIndex === 0) {
    box9ButLi[0].classList.add("is-false");
  }
  // 右边到头
  if (clickIndex >= maxSteps) {
    box9ButLi[1].classList.add("is-false");
  }
  // 还可以加 disabled 属性，便于无障碍
  box9ButLeft.disabled = clickIndex === 0;
  box9ButRight.disabled = clickIndex >= maxSteps;
}

// 根据 clickIndex 计算位移（负值向左移动）
function applyTransform() {
  const tx = -clickIndex * box9LiW;
  box9Ul.style.transform = `translateX(${tx}px)`;
}

// 左键
box9ButLeft.addEventListener('click', () => {
  if (clickIndex > 0) {
    clickIndex -= 1;
    applyTransform();
    updateButtons();
  }
});

// 右键
box9ButRight.addEventListener('click', () => {
  if (clickIndex < maxSteps) {
    clickIndex += 1;
    applyTransform();
    updateButtons();
  }
});

// 可选：监听 box9Div 的原生横向滚动（若用户也能拖动/滑动）
box9Div.addEventListener('scroll', () => {
  console.log('当前横向滑动距离:', box9Div.scrollLeft);
});
  

  // ========================================
  // Box13: 图标切换（保持原樣）
  // ========================================
  const box13Img = document.querySelectorAll(".box13-info .left .img-div>div");
  const box13Icon = document.querySelectorAll(".box13-info .left .tab-icon>div");

  box13Icon.forEach((link, index) => {
    const activateTab = () => {
      box13Icon.forEach(item => item.classList.remove("active"));
      box13Img.forEach(item => item.classList.remove("active"));
      box13Icon[index].classList.add("active");
      box13Img[index].classList.add("active");
    };

    link.addEventListener('mouseover', activateTab);
    link.addEventListener('click', activateTab);
  });

  
});


window.addEventListener("load", () => {
  const box4 = document.querySelector(".box4");
  const box9 = document.querySelector(".box9");
  const box5 = document.querySelector(".box5");
  const box11 = document.querySelector(".box11");
  const box12 = document.querySelector(".box12");


  const skip1 =  document.querySelector(".parameters-box .top .div1");
  const skip2 =  document.querySelector(".parameters-box .top .div2 .t1");
  const skip3 =  document.querySelector(".parameters-box .top .div2 .t2");
  const skip4 =  document.querySelector(".parameters-box .top .div3");
  const skip5 =  document.querySelector(".parameters-box .bottom .div1");
  const skip6 =  document.querySelector(".parameters-box .bottom .div2 .t1 .left");
  const skip7 =  document.querySelector(".parameters-box .bottom .div2 .t1 .right");
  const skip8 =  document.querySelector(".parameters-box .bottom .div2 .t2");


  // 点击滚到到元素位置
  function distanceToTop(clickEl,GoEl,Extension = 0){
    clickEl.addEventListener('click',()=>{
      
      let distanceToTop  = GoEl
      if(Extension){
        distanceToTop+=Extension
      }
      
      window.scrollTo({top:distanceToTop})
      // window.scrollTo({top:distanceToTop,behavior: "smooth"})
    })
  }
  distanceToTop(skip1,box4.offsetTop);
  distanceToTop(skip2,box9.offsetTop);
  distanceToTop(skip3,box5.offsetTop);
  distanceToTop(skip4,box11.offsetTop);
  distanceToTop(skip5,box12.offsetTop);
  distanceToTop(skip6,box5.offsetTop);
  distanceToTop(skip7,box5.offsetTop);
  distanceToTop(skip8,box5.offsetTop);
});
